/* Lichcards — klantvriendelijke conditienamen voor dynamische themadelen.
   De PowerTools-/Cardmarketwaarden in formulieren en URL's blijven ongewijzigd. */
(function () {
  if (window.lcConditionLabelsLoaded) return;
  window.lcConditionLabelsLoaded = true;

  var labels = {
    Good: 'Slightly Played'
  };

  function translateText(value) {
    var text = String(value || '');
    var exact = text.match(/^(\s*)(Good)(\s*(?:\(\d+\))?\s*)$/);
    if (exact) return exact[1] + labels[exact[2]] + exact[3];

    return text
      .replace(/ \/ (Good) \/ /g, function (_, condition) {
        return ' / ' + labels[condition] + ' / ';
      })
      .replace(/(:\s*)(Good)(\s*)$/, function (_, prefix, condition, suffix) {
        return prefix + labels[condition] + suffix;
      });
  }

  var selector = [
    '[data-selected-value]',
    '.facet-checkbox__text-label',
    '.facets__selected',
    '.active-facets__button-inner',
    '.product-edit-title-variant'
  ].join(',');

  function translateElement(element) {
    if (!(element instanceof Element)) return;
    if (element.matches(selector) && element.children.length === 0) {
      var translated = translateText(element.textContent);
      if (translated !== element.textContent) element.textContent = translated;
    }
    ['aria-label', 'title', 'data-label'].forEach(function (attribute) {
      if (!element.hasAttribute(attribute)) return;
      var current = element.getAttribute(attribute);
      var translated = translateText(current);
      if (translated !== current) element.setAttribute(attribute, translated);
    });
  }

  function scan(root) {
    if (root instanceof Element) translateElement(root);
    if (!(root instanceof Element || root instanceof Document)) return;
    root.querySelectorAll(selector).forEach(translateElement);
    root.querySelectorAll('[aria-label], [title], [data-label]').forEach(translateElement);
  }

  function start() {
    scan(document);
    if (!('MutationObserver' in window)) return;
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'characterData') {
          translateElement(mutation.target.parentElement);
          return;
        }
        mutation.addedNodes.forEach(function (node) {
          if (node instanceof Element) scan(node);
        });
      });
    }).observe(document.body, { childList: true, characterData: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
